import { ButtonHTMLAttributes, FC } from 'react';

type PrimaryButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const PrimaryButton: FC<PrimaryButtonProps> = ({
    className = '',
    disabled,
    children,
    ...props
}) => {
    return (
        <button
            {...props}
            className={
                `px-4 py-2 bg-gradient-to-b from-ocean-700 to-ocean-800 hover:from-ocean-400 hover:to-ocean-500 border border-transparent rounded-md text-white focus:outline-none focus:ring-2 focus:ring-brand-blue focus:ring-offset-2 transition ease-in-out duration-150 ${
                    disabled && 'opacity-25'
                } ` + className
            }
            disabled={disabled}>
            {children}
        </button>
    );
};
